import React, { useState } from "react";
import {
    Table,
    Input,
    Select,
    Row,
    Col,
    Card,
    Typography,
    Tooltip,
    Tag,
} from "antd";

const { Search } = Input;
const { Option } = Select;
const { Title } = Typography;

const dataBodegas = [
    { key: 1, codigoDane: "05250", departamento: "ANTIOQUIA", municipio: "EL BAGRE", paquetes: 1000, peso: 22.3, volumen: 33.6, entregas: 3 },
    { key: 2, codigoDane: "05790", departamento: "ANTIOQUIA", municipio: "TARAZÁ", paquetes: 1000, peso: 22.3, volumen: 33.6, entregas: 3 },
    { key: 3, codigoDane: "05736", departamento: "ANTIOQUIA", municipio: "SEGOVIA", paquetes: 1000, peso: 22.3, volumen: 33.6, entregas: 3 },
    { key: 4, codigoDane: "81736", departamento: "ARAUCA", municipio: "SARAVENA", paquetes: 1000, peso: 22.3, volumen: 33.6, entregas: 3 },
    { key: 5, codigoDane: "81794", departamento: "ARAUCA", municipio: "TAME", paquetes: 1000, peso: 22.3, volumen: 33.6, entregas: 3 },
    { key: 6, codigoDane: "81300", departamento: "ARAUCA", municipio: "FORTUL", paquetes: 1000, peso: 22.3, volumen: 33.6, entregas: 3 },
    { key: 7, codigoDane: "08758", departamento: "ATLÁNTICO", municipio: "SOLEDAD", paquetes: 1600, peso: 35.68, volumen: 53.76, entregas: 3 },
    { key: 8, codigoDane: "08433", departamento: "ATLÁNTICO", municipio: "MALAMBO", paquetes: 1000, peso: 22.3, volumen: 33.6, entregas: 3 },
    { key: 9, codigoDane: "08685", departamento: "ATLÁNTICO", municipio: "SANTO TOMÁS", paquetes: 500, peso: 11.15, volumen: 16.8, entregas: 3 },
    { key: 10, codigoDane: "13244", departamento: "BOLÍVAR", municipio: "EL CARMEN DE BOLÍVAR", paquetes: 1500, peso: 33.45, volumen: 50.4, entregas: 3 },
    { key: 11, codigoDane: "13654", departamento: "BOLÍVAR", municipio: "SAN JACINTO", paquetes: 1000, peso: 22.3, volumen: 33.6, entregas: 3 },
    { key: 12, codigoDane: "13894", departamento: "BOLÍVAR", municipio: "ZAMBRANO", paquetes: 1000, peso: 22.3, volumen: 33.6, entregas: 3 },
    { key: 13, codigoDane: "18001", departamento: "CAQUETÁ", municipio: "FLORENCIA", paquetes: 2000, peso: 44.6, volumen: 67.2, entregas: 3 },
    { key: 14, codigoDane: "18205", departamento: "CAQUETÁ", municipio: "CURILLO", paquetes: 1000, peso: 22.3, volumen: 33.6, entregas: 3 },
    { key: 15, codigoDane: "18256", departamento: "CAQUETÁ", municipio: "EL PAUJÍL", paquetes: 1000, peso: 22.3, volumen: 33.6, entregas: 3 },
];

const Bodegas = () => {
    const [busqueda, setBusqueda] = useState("");
    const [departamentoFiltro, setDepartamentoFiltro] = useState(null);
    const [municipioFiltro, setMunicipioFiltro] = useState(null);

    const departamentos = [...new Set(dataBodegas.map((b) => b.departamento))];
    const municipios = [...new Set(dataBodegas.map((b) => b.municipio))];

    const filtrarDatos = () => {
        return dataBodegas.filter((item) => {
            const matchSearch =
                busqueda === "" ||
                Object.values(item)
                    .join(" ")
                    .toLowerCase()
                    .includes(busqueda.toLowerCase());
            const matchDepto =
                !departamentoFiltro || item.departamento === departamentoFiltro;
            const matchMuni =
                !municipioFiltro || item.municipio === municipioFiltro;
            return matchSearch && matchDepto && matchMuni;
        });
    };

    const columns = [
        {
            title: "#",
            dataIndex: "key",
            key: "key",
            width: 50,
            align: "center",
        },
        {
            title: "CODIGO DANE MUN",
            dataIndex: "codigoDane",
            key: "codigoDane",
            width: 130,
            align: "center",
        },
        {
            title: "DEPARTAMENTO DESTINO",
            dataIndex: "departamento",
            key: "departamento",
            width: 180,
        },
        {
            title: "MUNICIPIO DESTINO",
            dataIndex: "municipio",
            key: "municipio",
            width: 200,
        },
        {
            title: "PAQUETES POR MUNICIPIO",
            dataIndex: "paquetes",
            key: "paquetes",
            align: "right",
            render: (num) => num.toLocaleString("es-ES"),
        },
        {
            title: "Peso x Entrega (kg)",
            dataIndex: "peso",
            key: "peso",
            align: "right",
            render: (num) => num.toLocaleString("es-ES", { minimumFractionDigits: 2 }),
        },
        {
            title: "VOLUMEN POR ENTREGA",
            dataIndex: "volumen",
            key: "volumen",
            align: "right",
            render: (num) => num.toLocaleString("es-ES", { minimumFractionDigits: 2 }),
        },
        {
            title: "ENTREGAS",
            dataIndex: "entregas",
            key: "entregas",
            align: "center",
            render: (num) => <Tag color="blue">{num}</Tag>,
        },
    ];

    return (
        <Card
            title={<Title level={4}>Bodegas — Distribución de Entregas</Title>}
            bordered
            style={{ margin: 20 }}
        >
            <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
                <Col xs={24} sm={12} md={8}>
                    <Search
                        placeholder="Buscar por cualquier campo"
                        allowClear
                        onChange={(e) => setBusqueda(e.target.value)}
                        value={busqueda}
                    />
                </Col>
                <Col xs={24} sm={12} md={8}>
                    <Select
                        placeholder="Filtrar por Departamento"
                        allowClear
                        style={{ width: "100%" }}
                        value={departamentoFiltro}
                        onChange={setDepartamentoFiltro}
                        showSearch
                    >
                        {departamentos.map((d) => (
                            <Option key={d} value={d}>
                                {d}
                            </Option>
                        ))}
                    </Select>
                </Col>
                <Col xs={24} sm={12} md={8}>
                    <Select
                        placeholder="Filtrar por Municipio"
                        allowClear
                        style={{ width: "100%" }}
                        value={municipioFiltro}
                        onChange={setMunicipioFiltro}
                        showSearch
                    >
                        {municipios.map((m) => (
                            <Option key={m} value={m}>
                                {m}
                            </Option>
                        ))}
                    </Select>
                </Col>
            </Row>

            <Table
                columns={columns}
                dataSource={filtrarDatos()}
                pagination={{ pageSize: 8 }}
                bordered
                scroll={{ x: true }}
                size="middle"
            />
        </Card>
    );
};

export default Bodegas;
